import { updateField } from 'vuex-map-fields';
export default {
    updateField,
    first_name(state, payload) {
        state.user = { ...state.user, first_name: payload };
    },
    last_name(state, payload) {
        state.user = { ...state.user, last_name: payload };
    },
    email(state, payload) {
        state.user = { ...state.user, email: payload };
    },
    nickname(state, payload) {
        state.user = { ...state.user, nickname: payload };
    },
    setUser(state, payload) {
        state.user = { ...payload };
    },
    setProfilePic(state, payload) {
        state.user = { ...state.user, profile_pic_url: payload };
    },
    setMobile(state, payload) {
        state.user = { ...state.user, mobile: payload };
    },
    setHomeCountry(state, payload) {
        state.user = { ...state.user, home_country: payload };
    },
    setDateOfBirth(state, payload) {
        state.user = { ...state.user, date_of_birth: payload };
    },
    setResidencyCountry(state, payload) {
        state.user = {
            ...state.user,
            profile: { ...state.user.profile, country_of_residence: payload }
        };
    },
    setBillingCountry(state, payload) {
        state.user = { ...state.user, billing_country: payload };
    },
    subscriptions(state, payload) {
        state.subscriptions = { ...state.subscriptions, ...payload };
    },
    payment(state, payload) {
        state.payment = { ...state.payment, ...payload };
    },
    setUseHomeAsBilling(state, payload) {
        state.use_home_as_billing = payload;
    },
    use_home_as_billing(state, payload) {
        state.use_home_as_billing = payload;
    },
    product(state, payload) {
        state.product = payload;
    },
    accepted_terms(state, payload) {
        state.user = { ...state.user, accepted_terms: payload };
    },
    // Used by AutoCompleteInput
    home_state(state, payload) {
        state.user = { ...state.user, home_state: payload };
    },
    home_house_name(state, payload) {
        state.user = { ...state.user, home_house_name: payload };
    },
    home_house_number(state, payload) {
        state.user = { ...state.user, home_house_number: payload };
    },
    home_street(state, payload) {
        state.user = { ...state.user, home_street: payload };
    },
    home_city(state, payload) {
        state.user = { ...state.user, home_city: payload };
    },
    home_postcode(state, payload) {
        state.user = { ...state.user, home_postcode: payload };
    },
    billing_state(state, payload) {
        state.user = { ...state.user, billing_state: payload };
    },
    billing_house_name(state, payload) {
        state.user = { ...state.user, billing_house_name: payload };
    },
    billing_house_number(state, payload) {
        state.user = { ...state.user, billing_house_number: payload };
    },
    billing_street(state, payload) {
        state.user = { ...state.user, billing_street: payload };
    },
    billing_city(state, payload) {
        state.user = { ...state.user, billing_city: payload };
    },
    billing_postcode(state, payload) {
        state.user = { ...state.user, billing_postcode: payload };
    },
    email_verified_at(state, payload) {
        state.user = { ...state.user, email_verified_at: payload };
    },
    clearHomeAddressFields(state) {
        state.user = {
            ...state.user,
            home_state: '',
            home_street: '',
            home_city: '',
            home_postcode: ''
        };
    },
    clearBillingAddressFields(state) {
        state.user = {
            ...state.user,
            billing_state: '',
            billing_street: '',
            billing_city: '',
            billing_postcode: ''
        };
    },
    setBillingFields(state, payload) {
        state.user = { ...state.user, ...payload };
    },
    setPurchaseOption(state, payload) {
        state.user = {
            ...state.user,
            profile: {
                ...state.user.profile,
                enrolment_purchase_option: payload
            }
        };
    },
    resetCurrentStage(state) {
        state.user = {
            ...state.user,
            profile: { ...state.user.profile, current_stage: null }
        };
    },
    updateState(state, { key, value }) {
        state.user = {
            ...state.user,
            [key]: value
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Enrolment/mutations.js